import { useInfiniteQuery } from '@tanstack/react-query'

import {
    getRecruitment,
    getRecruitmentQueryKey,
    type GetRecruitmentQueryParams,
} from '@/shared/api'
import { LIMIT_OPTIONS } from '@/shared/model'

interface UseRecruitmentFetchInfiniteProps {
    params: GetRecruitmentQueryParams
}

export const useRecruitmentFetchInfinite = ({ params }: UseRecruitmentFetchInfiniteProps) => {
    const {
        data,
        error,
        fetchNextPage,
        hasNextPage,
        isLoading,
        isFetching,
        isFetchingNextPage,
        status,
    } = useInfiniteQuery({
        queryKey: getRecruitmentQueryKey(params),
        queryFn: async ({ pageParam }) => {
            const { offset: _offset, ...rest } = params
            const response = await getRecruitment({
                ...rest,
                offset: pageParam,
            })

            return response
        },
        initialPageParam: params.offset ?? 0,
        getNextPageParam: (lastPage, _, lastPageParameter) => {
            if (!lastPage || !Array.isArray(lastPage.recruitment)) return undefined

            if (lastPage.recruitment.length < LIMIT_OPTIONS[0]) return undefined

            return lastPageParameter + LIMIT_OPTIONS[0]
        },
        refetchOnMount: true,
        refetchOnWindowFocus: false,
    })

    return {
        recruitment: data?.pages.flatMap((page) => page.recruitment),
        total: data?.pages[0]?.meta?.total ?? 0,
        fetchNextPage,
        hasNextPage,
        isFetching,
        isLoading,
        isFetchingNextPage,
        status,
        error,
    }
}
